<template><section><h1>Bar</h1>
<blockquote>
<p>栏</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>size</td>
<td style="text-align:left">容器高度（使用outer标准），可选值 <code>sm</code>/<code>md</code>/<code>lg</code></td>
<td><code>String</code></td>
<td><code>md</code></td>
</tr>
<tr>
<td>use_padding</td>
<td style="text-align:left">是否包含内边距（outer - inner）</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Bar.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-22.vue?58a9bd9c